export default "__VITE_ASSET__B$ndEWMl__"